export default () => `
  <div class="content">
    Attaching on Direct-To-Deck (OSB or Plywood) requires 6 screws.
  </div>
`;